const { Button, CardSection } = require('@paymongo/seeds');

const InvalidToken = () => {
  const redirectToShopify =  () => {
    const appSettingsUrl: string = new URLSearchParams(document.location.search).get('app_settings_url') || '';
    window.location.href = appSettingsUrl;
  }

  return (
    <CardSection>
      <h2>PayMongo Shopify Settings</h2>

      <p>
        Sorry! The page you are trying to access is either invalid or has already expired. <br />
        Kindly go back to Shopify and try again.
      </p>

      <Button type="default" className="text --bold" onClick={ redirectToShopify }>
        Go Back to Shopify
      </Button>
    </CardSection>
  );
}

export default InvalidToken;
